import { createRoot } from 'react-dom/client';
import styled from 'styled-components';
import ClickableContainer from '../pages/h_cctv/RealtimeCCTV/ClickableContainer';

class CustomBoxStyleRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const root = createRoot(this.element);
    const { name, backColor, fontColor } = props.value;

    root.render(
      <div style={{ backgroundColor: backColor, color: fontColor, borderRadius: '3px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 4px' }}>
        <span>{name}</span>
      </div>
    );
  }

  getElement() {
    return this.element;
  }
}
export default CustomBoxStyleRenderer;
